import React from "react";
import PropTypes from "prop-types";
import { ImageContainer, ImageElement } from "./Image.styled";

const Image = (props) => {
  return (
    <ImageContainer>
      <ImageElement
        src={props.image}
        height={props.height}
        width={props.width}
        objectFit={props.objectFit}
      />
    </ImageContainer>
  );
};
Image.propTypes = {
  alt: PropTypes.string,
  image: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  objectFit: PropTypes.string,
};

Image.defaultProps = {
  height: "400px",
  objectFit: "cover",
  width: "auto",
};
export default Image;
